import { render, staticRenderFns } from "./vendors-summary-card.vue?vue&type=template&id=cd1572a4&scoped=true&"
import script from "./vendors-summary-card.vue?vue&type=script&lang=js&"
export * from "./vendors-summary-card.vue?vue&type=script&lang=js&"
import style0 from "./vendors-summary-card.vue?vue&type=style&index=0&id=cd1572a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1572a4",
  null
  
)

export default component.exports